export default {"src":"/_next/static/media/powered-by-porsyar.f3d87e81.svg","height":555,"width":935,"blurWidth":0,"blurHeight":0};